export enum SerializedItemHistoricalFieldsEnum {
	Status = 'Status'
}